package ui.new_ui.components.loaders.circle_loaders

import react.FC
import react.dom.html.ReactHTML
import ui.new_ui.components.loaders.props.CircleLoaderProps
import ui.new_ui.components.loaders.props.MainLoaderProps
import web.cssom.ClassName

val CircleLoader = FC<CircleLoaderProps> { props->
    if (props.isLoading){
        ReactHTML.span {
            className = ClassName("loader-circle-load")
        }
    }
}